import {merge,isMatch} from 'lodash'
import {timeToISO8061} from './cesiumUtils'
import {hashCode, hex2rgb, colores_google} from "./commonUtils";


export const handleColumns = (columns, userSettings, items) => {
  const settings = merge({
    "maxVisibleColumn": 7,
    "showOnlyIfHasOneValue": true,
  }, userSettings);

  let visibleColCounter = 0;

  const resultColumns = columns.map(e => {
    if (e.visible) visibleColCounter++;
    e.visible = visibleColCounter > settings.maxVisibleColumn ? false : e.visible;
    return e;
  });

  return resultColumns
};

export function matcher(object,matchOptions){
  return matchOptions.find(e=>e.match.find(match=>isMatch(object,match)))
}

export function getGoogleColorByString(str) {
  return colores_google(hashCode(str));
}

export function getGoogleRGBAColorByString(str) {
  const rgbColor = hex2rgb(getGoogleColorByString(str));
  return [rgbColor.r, rgbColor.g, rgbColor.b, 255];
}

function normalizeArray(array) {
  return array.reduce((prev, current) => current ? prev.concat(current) : prev, [])
}

export function getPositionForSatellite(ballisticApiLinks, satellite, startTime, step, duration) {
  let command;
  if (satellite.keplerOrbit !== null) command = Vue.axios.post(ballisticApiLinks.kepler, {
    keplerOrbit: satellite.keplerOrbit,
    startTime,
    duration,
    step
  });
  else if (satellite.cartesianOrbit !== null) command = Vue.axios.post(ballisticApiLinks.catesianOrbit, {
    cartesianOrbit: satellite.cartesianOrbit,
    startTime,
    duration,
    step
  });
  else if (satellite.tle !== null) command = Vue.axios.post(ballisticApiLinks.tle, {
    tle1: satellite.tle.str1,
    tle2: satellite.tle.str2,
    startTime,
    duration,
    step
  });

  if (!command) throw new Error("Unknow type orbit for satellite - " + satellite.label);

  return command.then(responce => responce.data.content)
    .then(position => normalizeArray(position))//нормализация массива
    .then(position => ({position, startTime, step, duration}))
}

export function getVisiblePeriod(link, satellite, epoch, step, duration, groundstation, angleElavation) {
  return Vue.axios.post(link, {
    tle: satellite.tle,
    epoch,
    duration,
    step,
    lat: groundstation.latitude,
    lon: groundstation.longitude,
    alt: groundstation.altitude,
    angleElavation
  }).then(result => result.data).then(data => {
    return {
      position: normalizeArray(data.position),
      show: periodVisibleTransform(data.periodVisible),
      startTime: epoch
    }
  });

  function periodVisibleTransform(periodVisible) {
    const show = [];

    const endTime = epoch + duration + 31536000000;

    show.push(
      {
        "interval": "0000-01-01T00:00:00Z/" + timeToISO8061(periodVisible.length ? periodVisible[0][0] : endTime),
        "boolean": false
      }
    );

    for (let i = 0; i < periodVisible.length; i++) {
      show.push(
        {
          "interval": timeToISO8061(periodVisible[i][0]) + "/" + timeToISO8061(periodVisible[i][1]),
          "boolean": true
        }
      );
      show.push(
        {
          "interval": timeToISO8061(periodVisible[i][1]) + "/" + timeToISO8061(i < periodVisible.length - 1 ? periodVisible[i + 1][0] : endTime),
          "boolean": false
        }
      );
    }

    return show;
  }
}

export function getShootingStrip(apiLink, {startTime, endTime, attributes, capability}, size) {
  const satellite = capability.resource;
  const cameraEquipment = satellite.equipments[0];

  return Vue.axios.post(apiLink, {
    startTime,
    endTime,
    step: (endTime - startTime) / size,
    rollAttitude: attributes.satelliteRollAngle,
    pitchAngle: attributes.satellitePitchAngle,
    satellite: {
      id: satellite.id,
      tle: satellite.tle,
      keplerOrbit: satellite.keplerOrbit,
      cartesianOrbit: satellite.cartesianOrbit,
      cameraFromNadirDeviation: cameraEquipment.maxRollAngle,
      equipment: [
        {
          CCDArrayLength: cameraEquipment.ccdArrayLength,
          elementOfCCDArraySize: cameraEquipment.elementOfCCDArraySize,
          focalLength: cameraEquipment.focalLength,
          shootingDurationLimit: cameraEquipment.maxDurationOneShoot,
          betweenShotsInterval: cameraEquipment.minDurationBetweenShoots,
        }
      ]
    }
  }).then(result => result.data)
    .then(({position, shootingStrip, shootingArea}) => ({
      position: normalizeArray(position),
      shootingStrip: [
        normalizeArray(shootingStrip[0]),
        normalizeArray(shootingStrip[1])
      ],
      shootingArea,
      startTime,
      endTime
    }))
}

export function getShootingArea(apiLink, {startTime, endTime, attributes, capability}) {
  const satellite = capability.resource;
  const cameraEquipment = satellite.equipments[0];

  return Vue.axios.post(apiLink, {
    startTime,
    endTime,
    rollAttitude: attributes.satelliteRollAngle,
    pitchAngle: attributes.satellitePitchAngle,
    satellite: {
      id: satellite.id,
      tle: satellite.tle,
      keplerOrbit: satellite.keplerOrbit,
      cartesianOrbit: satellite.cartesianOrbit,
      cameraFromNadirDeviation: cameraEquipment.maxRollAngle,
      equipment: [
        {
          CCDArrayLength: cameraEquipment.ccdArrayLength,
          elementOfCCDArraySize: cameraEquipment.elementOfCCDArraySize,
          focalLength: cameraEquipment.focalLength,
          shootingDurationLimit: cameraEquipment.maxDurationOneShoot,
          betweenShotsInterval: cameraEquipment.minDurationBetweenShoots,
        }
      ]
    }
  }).then(result => result.data.content)
    .then(shootingArea => ({
      shootingArea,
      startTime,
      endTime
    }))
}

export function cesiumTimeLineEntityFun({id, label, startTime, requirement}) {
  return Promise.resolve({
    id, label, startTime,
    position: {lat: requirement.task.latitude, lng: requirement.task.longitude, alt: 300000}
  })
}

export function getAreaObjectForShootingColor(endTime) {
  return [{
    interval: "1900-01-01T00:00:00Z/" + timeToISO8061(endTime),
    rgba: [255, 255, 0, 100]
  }, {
    interval: timeToISO8061(endTime) + "/2100-01-01T00:00:00Z",
    rgba: [0, 255, 255, 150]
  }]
}
